import axios from "axios";
import urlManager from "./urlManager";

// Table
Array.from(document.querySelectorAll('.table')).forEach(function(table) {

    let modal = table.closest('.modal');

    if (modal) {

        let table_header = table.querySelector('.table-header');
        let table_body = table.querySelector('.table-items');

        // Check all toggles
        Array.from(modal.querySelectorAll('.check-all-items')).forEach(function(check_all_toggle) {

            check_all_toggle.onchange = function() {

                Array.from(table_body.querySelectorAll('.table-checkbox [type="checkbox"]')).forEach(_ => _.checked = check_all_toggle.checked);

            }

        });

        // Sorting
        Array.from(modal.querySelectorAll('[name="sorting"]')).forEach(function(sort_input) {
            sort_input.addEventListener('change', function() {
                __toggleAllRowSelections(modal, false);

                let sort_by = this.selectedOptions[0].value;
                urlManager.updateURL('page', '1');
                urlManager.updateAndGo("sort", sort_by);
            });

        });

        // Search
        Array.from(modal.querySelectorAll('[name="search"]')).forEach(function(search_input) {

            search_input.addEventListener('search', function(e) {
                // __toggleAllRowSelections(modal, false);

                let query = this.value.trim();
                if (!query.length) {
                    query = null; 
                }

                urlManager.updateURL('page', '1');
                urlManager.updateAndGo("q", query);
                return false;
            });

        });

        // Filter
        Array.from(modal.querySelectorAll('select.filter-select')).forEach(function(filter_input) {
            filter_input.addEventListener('change', function() {

                let filter_column = filter_input.getAttribute('name');
                let filter_for = this.selectedOptions[0].value;
                urlManager.updateAndGo(filter_column, filter_for);
            });

        });


        // Body / Row Clicks
        table_body.onclick = function(e) {

            let hasRowClicked = e.target.closest('.table-row');

            if (hasRowClicked) {

                // Check for Row Checkbox
                let checkboxCell = e.target.closest('.checkbox');

                if (checkboxCell) {
                    let checkbox = checkboxCell.querySelector('[type="checkbox"]');

                    checkbox.checked = !checkbox.checked;

                    let hasAllRowsSelected = Array.from(table_body.querySelectorAll('.table-checkbox [type="checkbox"]')).every(_ => _.checked);
                    Array.from(modal.querySelectorAll('.check-all-items')).forEach( _ => _.checked = hasAllRowsSelected);

                    return false;
                }


            }
        }
        
    }

});


Array.from(document.querySelectorAll('[name="per_page"]')).forEach(function(pp_select) {

    pp_select.addEventListener('change', function(select) {
        urlManager.updateAndGo('per_page', pp_select.selectedOptions[0].value);
    })

});


function __toggleAllRowSelections(table, checked) {
    checked = checked || false;

    Array.from(table.querySelectorAll('.check-all-items')).forEach(_ => _.checked = checked);
    Array.from(table.querySelectorAll('.table-items .table-checkbox [type="checkbox"]')).forEach(_ => _.checked = checked);
}